/**
 * Centralized component exports
 * This file provides a single entry point for importing components
 */

// Layout Components
export { default as Footer } from './layout/Footer';
export { default as Header } from './layout/Header';
export { default as StoreSelector } from './layout/StoreSelector';
export { default as FulfillmentToggle } from './layout/FulfillmentToggle';
export { default as UserMenu } from './layout/UserMenu';
export { default as CartButton } from './layout/CartButton';
export { default as SearchBar } from './layout/SearchBar';
export { default as NavigationMenu } from './layout/NavigationMenu';
export { default as LocationModal } from './layout/LocationModal';

// Section Components
export { default as BenefitsSection } from './sections/BenefitsSection';
export { default as BlogsSection } from './sections/BlogsSection';
export { default as BlogListingSection } from './sections/BlogListingSection';
export { default as DankLifestyleSection } from './sections/DankLifestyleSection';
export { default as FAQSection } from './sections/FAQSection';
export { default as JoinTheFamSection } from './sections/JoinTheFamSection';
export { default as RecentDealsSection } from './sections/RecentDealsSection';
export { default as ReviewsSection } from './sections/ReviewsSection';
export { default as WaysToOrderSection } from './sections/WaysToOrderSection';

// Modal Components
export { default as BannerSlot5Modal } from './modals/BannerSlot5Modal';
export { default as EntryModal } from './modals/EntryModal';
export { default as EntryModalWrapper } from './modals/EntryModalWrapper';

// UI Components
export { default as CartDrawer } from './contexts/CartDrawer';
export { default as CollectionEmbed } from './ui/CollectionEmbed';
export { default as CollectionsList } from './ui/CollectionsList';
export { default as BrandsList } from './ui/BrandsList';
export { default as ProductCard } from './ui/ProductCard';
export { default as ProductFilters } from './ui/ProductFilters';
export { default as ProductSlider } from './ui/ProductSlider';
export { default as ScrollFade } from './ui/ScrollFade';
export { default as Breadcrumbs } from './ui/Breadcrumbs';
export type { BreadcrumbItem, BreadcrumbsProps } from './ui/Breadcrumbs';
export { default as Select } from './ui/Select';
export { default as DatePickerModal } from './ui/DatePickerModal';
export { default as SponsoredBanners } from './ui/SponsoredBanners';
export { default as Button } from './ui/Button';
export type { ButtonProps } from './ui/Button';
export { default as Checkbox } from './ui/Checkbox';
export type { CheckboxProps } from './ui/Checkbox';
export { default as ModalCloseButton } from './ui/ModalCloseButton';
export type { ModalCloseButtonProps } from './ui/ModalCloseButton';
export { default as ModalPortal } from './ui/ModalPortal';
export { SponsoredBannersProvider, useSponsoredBanners } from './providers/SponsoredBannersProvider';

// Feature Components
// Lazy wrapper, defers Google Maps JS (~168 KiB) until the section
// approaches the viewport. Direct-import './features/DispensaryLocations'
// only if you actually need the eager version (e.g. above-the-fold pages).
export { default as DispensaryLocations } from './features/DispensaryLocationsLazy';
export { default as HomePageRedirect } from './features/HomePageRedirect';
export { default as PostalSearch } from './features/PostalSearch';

// Context Providers
export { CartProvider, useCart } from './contexts/CartContext';
export { default as Providers } from './contexts/Providers';
export {
  PageShowcasesProvider,
  usePageShowcases,
  HomepageShowcasesProvider,
  useHomepageShowcases,
} from './providers/PageShowcasesProvider';

// Re-export types from Select component
export type { SelectOption, SelectProps } from './ui/Select';
export type { DatePickerModalProps } from './ui/DatePickerModal';

